import React, { useEffect, useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import MenuBottom from "./MenuBottom";
import { ContentMain, StyledHeaderMenu } from "./MenuStyles";
import MenuTop from "./MenuTop";
import Sidebar from "./Sidebar";
import { setToastData } from "../../app/toastReducer";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useTheme } from "../../context/themeContext";
import ToastNotification from "../shared/ToastNotification";

type Props = {
  children: React.ReactNode;
  breadcrumbs?: JSX.Element;
  buttons?: JSX.Element;
  email?: JSX.Element;
  modalIsActive?: boolean;
};

const Menu = ({ children, breadcrumbs, buttons, email }: Props) => {
  const [width] = useWindowSize();
  const [sidebarIsActive, setSidebarIsActive] = useState(false);
  const toastData = useAppSelector((state) => state.toast);

  const dispatch = useAppDispatch();
  const theme = useTheme().theme;

  useEffect(() => {
    if (width > 1440) {
      setSidebarIsActive(true);
    } else {
      setSidebarIsActive(false);
    }
  }, [width]);

  return (
    <>
      <StyledHeaderMenu>
        <MenuTop />
        <MenuBottom
          sidebarIsActive={sidebarIsActive}
          setSidebarIsActive={setSidebarIsActive}
          breadcrumbs={breadcrumbs}
          buttons={buttons}
        />
      </StyledHeaderMenu>

      <Sidebar
        sidebarIsActive={sidebarIsActive}
        setSidebarIsActive={setSidebarIsActive}
      />

      <ContentMain isActive={sidebarIsActive} theme={theme}>
        {children}
      </ContentMain>

      <ToastNotification
        message={toastData.toastMessage}
        isActive={toastData.isToastActive}
        setIsActive={(value: any) => {
          dispatch(
            setToastData({
              toastMessage: toastData.toastMessage,
              isToastActive: false,
              toastType: toastData.toastType,
            })
          );
        }}
        status={toastData.toastType}
      />
    </>
  );
};

export default Menu;
